module.exports = __webpack_public_path__ + "img/packandpedal.d21467da.png";